import { createContext } from "react";

export enum RequestState {
  Idle,
  Error,
  Fetching,
  Finished,
}

export interface IRequestContext {
  state: RequestState;
  errorMessage: string | undefined;
  send: (
    promise: Promise<any>,
    onSuccess?: (response: any | undefined) => void,
    onError?: (error: Error) => void,
  ) => Promise<any> | undefined;
  setState: (state: RequestState) => void;
}

const defaultValue: IRequestContext = {
  state: RequestState.Idle,
  errorMessage: undefined,
  send: () => undefined,
  setState: () => {},
};

export const RequestContext = createContext(defaultValue);
